import styled from '@emotion/styled';
import { AdAnalyticsVideo } from '@kaizenplatform/hugot-entity';
import { Table, TableBody } from '@material-ui/core';
import _TableCell from '@material-ui/core/TableCell';
import _TableRow from '@material-ui/core/TableRow';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  analyticsVideo: AdAnalyticsVideo;
};

const DateTable: FC<Props> = ({ analyticsVideo }: { analyticsVideo: AdAnalyticsVideo }) => {
  return (
    <Table cellPadding="none" padding="none">
      <TableBody>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CV</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.conversions !== null ? (
              <ConversionWrapper>
                <Value>{analyticsVideo.conversions}</Value>
                <ConversionKey>
                  (<FormattedMessage id={`adAnalytics_cv_key.${analyticsVideo.conversionsKey}`} />)
                </ConversionKey>
              </ConversionWrapper>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CVR</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.cvr !== null ? (
              <>
                <Value>{analyticsVideo.cvr}</Value>
              </>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CTR</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.ctr !== null ? (
              <>
                <Value>{analyticsVideo.ctr}</Value>
              </>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CPA</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.cpa !== null ? (
              <>
                <PriceUnit>
                  {analyticsVideo.currency === 'JPY'
                    ? '¥'
                    : analyticsVideo.currency === 'USD'
                    ? '$'
                    : analyticsVideo.currency}
                </PriceUnit>
                <Value>{analyticsVideo.cpa}</Value>
              </>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CPC</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.cpc !== null ? (
              <>
                <PriceUnit>
                  {analyticsVideo.currency === 'JPY'
                    ? '¥'
                    : analyticsVideo.currency === 'USD'
                    ? '$'
                    : analyticsVideo.currency}
                </PriceUnit>
                <Value>{analyticsVideo.cpc}</Value>
              </>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component={'th' as any} scope="row" padding="none">
            <Label>CPM</Label>
          </TableCell>
          <TableCell>
            {analyticsVideo.cpm !== null ? (
              <>
                <PriceUnit>
                  {analyticsVideo.currency === 'JPY'
                    ? '¥'
                    : analyticsVideo.currency === 'USD'
                    ? '$'
                    : analyticsVideo.currency}
                </PriceUnit>
                <Value>{analyticsVideo.cpm}</Value>
              </>
            ) : (
              <Value>-</Value>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

const Value = styled('span')({
  fontSize: '20px',
  fontWeight: 700,
  color: 'rgba(0,0,0,.66)',
});

const Label = styled('span')({
  fontSize: '14px',
  color: 'rgba(0,0,0,.54)',
});

const TableRow = styled(_TableRow)({
  height: '30px',
});

const TableCell = styled(_TableCell)({
  paddingLeft: '8px',
});
// const PercentUnit = styled('span')({
//   fontSize: '14px',
//   paddingLeft: '4px',
//   color: 'rgba(0,0,0,.54)',
// });

const ConversionKey = styled('span')({
  fontSize: '12px',
  marginTop: '4px',
  color: 'rgba(0,0,0,.54)',
});

const ConversionWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 0px',
});

const PriceUnit = styled('span')({
  fontSize: '14px',
  paddingRight: '4px',
  color: 'rgba(0,0,0,.54)',
});
export default DateTable;
